var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplatePageGrid',{attrs:{"items":_vm.notificationUserGrid,"loading":false,"content_only":""}},[_c('div',{staticClass:"notifications-history"},_vm._l((_vm.notificationUserGrid),function(notification,key){return _c('HeaderNotificationListItem',{key:key,attrs:{"notification":notification,"observer":_vm.observer,"index":key}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }